import {
  NBS_API_TRACK_AFFILIATE_CLICK_REQUEST,
  NBS_API_TRACK_AFFILIATE_CLICK_SUCCESS,
  NBS_API_TRACK_AFFILIATE_CLICK_FAILURE
} from '../../constants/actions';
import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiTrackAffiliateClickRequest () {
  return { type: NBS_API_TRACK_AFFILIATE_CLICK_REQUEST };
}
function nbsApiTrackAffiliateClickSuccess (response) {
  return {
    type: NBS_API_TRACK_AFFILIATE_CLICK_SUCCESS,
    response
  };
}
function nbsApiTrackAffiliateClickError (error) {
  return {
    type: NBS_API_TRACK_AFFILIATE_CLICK_FAILURE,
    error: error.cause || error
  };
}
export function nbsApiTrackAffiliateClick (data) {
  const url = 'trackAffiliateClick';
  if (!data.language && strings.getLanguage()) {
    data.language = strings.getLanguage();
  }
  return dispatch => {
    dispatch(nbsApiTrackAffiliateClickRequest());
    return nbsApi(url, data)
      .then(response => dispatch(nbsApiTrackAffiliateClickSuccess(response)))
      .catch(error => dispatch(nbsApiTrackAffiliateClickError(error)));
  };
}
